import type { NextPage } from 'next'
import { joinClassnames } from 'helpers/classNames'
import styles from '../../styles/Row.module.scss'
interface Props {
  center?: boolean
  children: any
  gap?: boolean
  gapValue?: string
  fullWidth?: boolean
  noPadding?: boolean
  align?: boolean,
  backgroundColor?: string
  childrenSameSize?: boolean
  childrenSize?: string
  alignRight?: boolean
  spaceAround?: boolean
  spaceBetween?: boolean
  height?: string
  sticky?: boolean
  alignTop?: boolean
  centerH?: boolean
  equalChildren?: boolean
  shadow?: boolean
}
const RowComponent: NextPage<Props> = (props: Props) => {
  const className = joinClassnames([
    styles.container,
    props.center && styles.center,
    props.gap && styles.gap,
    props.gapValue === "1" && styles.gap1,
    props.gapValue === "2" && styles.gap2,
    props.gapValue === "3" && styles.gap3,
    props.gapValue === "4" && styles.gap4,
    props.gapValue === "5" && styles.gap5,
    props.childrenSameSize && styles.childrenSameSize,
    props.spaceAround && styles.spaceAround,
    props.spaceBetween && styles.spaceBetween,
    props.noPadding && styles.no_padding,
    !props.noPadding && styles.padding,
    props.fullWidth && styles.fullWidth,
    props.align && styles.align,
    props.alignRight && styles.alignRight,
    props.childrenSize === "small" && styles.smallChildren,
    props.sticky && styles.sticky,
    props.alignTop && styles.alignTop,
    props.centerH && styles.centerH,
    props.equalChildren && styles.equalChildren,
    props.shadow && styles.shadow
  ])
  return <div className={className} style={{ backgroundColor: props.backgroundColor, height: props.height }}>{props.children}</div>
}

export default RowComponent
